var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9 mt-5"},[(_vm.isYoutube())?_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.url,"allowfullscreen":""}}):_vm._e(),(_vm.isVimeo())?_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.url,"allowfullscreen":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }